export const SIDEBAR_COMPONENT_LOADER = {
  'task-list': () =>
    import('../../../submissions/next/sidebar/features/task-list/task-list.component').then(
      (m) => m.TaskListComponent,
    ),
  'collaboration-hub': () =>
    import('../../../submissions/next/content/collaboration-hub/collaboration-hub/collaboration-hub.component').then(
      (m) => m.CollaborationHubComponent,
    ),
};
